export const is8InchScreen = window.innerWidth < 1300